module.exports = __webpack_public_path__ + "static/media/neetha.96c6546f.jpeg";